"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/*global google*/
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@react-google-maps/api");
const google_maps_context_provider_1 = require("../google-maps-context-provider");
require("./styles.scss");
const getIcon_1 = __importDefault(require("../../utils/getIcon"));
const LocationMapWithMarker = ({ lat, lng, customMapHeight, customParentContainerWidth }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isLoaded, loadError } = (0, react_1.useContext)(google_maps_context_provider_1.GoogleMapsContext);
    const mapHeight = customMapHeight !== null && customMapHeight !== void 0 ? customMapHeight : `13.1875rem`;
    const renderMap = (0, react_1.useMemo)(() => {
        return (lat === undefined || lng === undefined) ?
            (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) :
            loadError ?
                t("mapWithMarker.error") :
                isLoaded ?
                    (0, jsx_runtime_1.jsx)(api_1.GoogleMap, Object.assign({ mapContainerStyle: {
                            width: "100%",
                            height: mapHeight,
                        }, options: {
                            zoom: 14,
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: false,
                            styles: [
                                {
                                    featureType: "all",
                                    elementType: "labels.text",
                                    stylers: [
                                        {
                                            visibility: "on",
                                        },
                                    ],
                                },
                            ],
                            center: { lat, lng },
                        } }, { children: (0, jsx_runtime_1.jsx)(api_1.MarkerF, { options: {
                                optimized: false,
                                icon: (0, getIcon_1.default)({ selected: false, hovered: false })
                            }, position: { lat, lng } }) })) :
                    t("mapWithMarker.loading");
    }, [lat, lng, loadError, isLoaded]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `ontario-small-12 ontario-columns ${customParentContainerWidth !== null && customParentContainerWidth !== void 0 ? customParentContainerWidth : 'ontario-medium-4'}` }, { children: renderMap })));
};
exports.default = LocationMapWithMarker;
